
export function isJSON (obj) {
  return (obj && typeof obj === 'object' && !Array.isArray(obj) && obj !== null) ? true : false;
}